import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faUserPlus, faArrowsRotate, faUserPen } from "@fortawesome/free-solid-svg-icons";
import Address from "./Address";
import CustomerModal from "../../../../crm/Shared/CustomerModal";
import CreateCustomerModal from "../../../../crm/Shared/CreateCustomerModal";
import Finance from "@serie3/freelancesplaceapi/Domain/Billing/Outgoing/Finance";
import FinanceForm from "@serie3/freelancesplaceapi/Form/Billing/FinanceForm";

const inputStyle = {
  width: "100%", padding: "8px 12px", border: "1px solid #e0e0e0",
  borderRadius: "8px", fontSize: "0.92rem", color: "#212121",
  background: "#fff", outline: "none", boxSizing: "border-box",
};

const labelStyle = {
  fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase",
  letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "6px", display: "block",
};

const BillingHeaderLeft = ({ bill, contact, setContact, setAddress, addressJson = "{}", formik, onContactUpdated }) => {
  const [showCustomers, setShowCustomers] = useState(false);
  const [showCreateCustomer, setShowCreateCustomer] = useState(false);

  const updateContact = async (selectedContact) => {
    const response = await Finance.updateContact(bill, selectedContact, setAddress);
    if (response.status === 200) {
      if (onContactUpdated) {
        await onContactUpdated();
      } else {
        if (typeof formik !== "undefined") {
          formik.setValues(FinanceForm.setEditData(response.data));
        }
        setContact(selectedContact);
      }
    }
  };

  const btnBase = {
    display: "inline-flex", alignItems: "center", gap: "6px",
    padding: "7px 12px", border: "none", borderRadius: "8px",
    fontSize: "0.82rem", fontWeight: 600, cursor: "pointer",
  };

  return (
    <>
      <CustomerModal show={showCustomers} setShow={setShowCustomers} updateContact={updateContact} />
      <CreateCustomerModal show={showCreateCustomer} setShow={setShowCreateCustomer} updateContact={updateContact} billId={bill?.id} />

      <div style={{ marginBottom: "16px" }}>
        <label style={labelStyle}>Bill Number</label>
        <input
          type="text"
          name="rechnungs_nummer"
          placeholder="Auto-generated"
          value={formik.values.rechnungs_nummer}
          onChange={formik.handleChange}
          style={inputStyle}
        />
      </div>

      <div style={{
        background: "#f8f9fb", borderRadius: "10px", padding: "14px 16px", marginBottom: "12px",
      }}>
        <label style={labelStyle}>Bill To</label>
        <div style={{ marginBottom: "12px", fontSize: "0.92rem", lineHeight: 1.7, color: "#424242" }}>
          <Address addressJson={addressJson} style={{ margin: 0 }} />
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          {contact?.id ? (
            <>
              <button type="button" style={{ ...btnBase, background: "#e8f0fe", color: "#1a73e8" }}
                onClick={() => setShowCustomers(true)}>
                <FontAwesomeIcon icon={faArrowsRotate} /> Change
              </button>
              <button type="button" style={{ ...btnBase, background: "#ffebee", color: "#c62828" }}
                onClick={() => {
                  setContact(null);
                  setAddress("{}");
                  formik.setFieldValue("kunde", null);
                  formik.setFieldValue("person", null);
                }}>
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </>
          ) : (
            <>
              <button type="button" style={{ ...btnBase, background: "#e8f0fe", color: "#1a73e8" }}
                onClick={() => setShowCustomers(true)}>
                <FontAwesomeIcon icon={faUserPlus} /> Pick Customer
              </button>
              <button type="button" style={{ ...btnBase, background: "#e8f5e9", color: "#2e7d32" }}
                onClick={() => setShowCreateCustomer(true)}>
                <FontAwesomeIcon icon={faUserPen} /> New Contact
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default BillingHeaderLeft;
